"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _objectDestructuringEmpty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectDestructuringEmpty.js"));
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.map");
var _slicedToArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.function.name");
var _readOnlyError2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/readOnlyError.js"));
var _lodash = _interopRequireDefault(require("lodash"));
var _StepNav = _interopRequireDefault(require("./components/StepNav.vue"));
var _StoreInfoStep = _interopRequireDefault(require("./components/Step/StoreInfoStep.vue"));
var _SalesStep = _interopRequireDefault(require("./components/Step/SalesStep.vue"));
var _TPPRecordsStep = _interopRequireDefault(require("./components/Step/TPPRecordsStep.vue"));
var _SalesRecordStep = _interopRequireDefault(require("./components/Step/SalesRecordStep.vue"));
var _TrainingRecordStep = _interopRequireDefault(require("./components/Step/TrainingRecordStep.vue"));
var _VisitorRecordsStep = _interopRequireDefault(require("./components/Step/VisitorRecordsStep.vue"));
var _doubleWeekPlan = require("@/http/interface/sfe/doubleWeekPlan");
var _validate = require("@/utils/validate");
var _storage = require("@/utils/storage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/** package */

/** components */

/** services */

/** utils */

/** statics */
var STORE_STEP = 'storeVisitReport_step'; // 本地存储key
// 销售情况单个数据的demo格式
var TireSales_demo = {
  tireBrand: '',
  // 轮胎品牌
  tireSupplier: '',
  // 主要进货渠道 (DIS/SP 代理商 /Whole sales 批发商)
  paymentTerms: '',
  // 结款方式（现结/账期）
  monthlyAvgSales: undefined,
  // 月均销量
  stock: undefined // 库存
};
var _default = exports.default = {
  components: {
    StepNav: _StepNav.default,
    StoreInfoStep: _StoreInfoStep.default,
    SalesStep: _SalesStep.default,
    TPPRecordsStep: _TPPRecordsStep.default,
    SalesRecordStep: _SalesRecordStep.default,
    TrainingRecordStep: _TrainingRecordStep.default,
    VisitorRecordStep: _VisitorRecordsStep.default
  },
  data: function data() {
    var _this2 = this;
    var defaultForm = {
      // step1 门店信息
      storeInfo: {
        /** 基本信息 */
        // rtlRtmCategory: '', // 零售店RTM类别
        // retailerType: '', // 零售店类别
        // retailerTypeDescription: '', // 零售店类别描述
        // rtlSapId: '', // 客户编号
        rtlFullName: '',
        // 店名
        rtlAddress: '',
        // 地址
        PCD: [],
        // 省市区 不传后端
        rtlRegion: '',
        // 省label
        rtlRegionCode: '',
        // 省
        rtlCity: '',
        // 市label
        rtlCityCode: '',
        // 市
        rtlDistrict: '',
        // 区label
        rtlDistrictCode: '',
        // 区
        contactsNameOne: '',
        // 联系人1
        contactsMobileOne: '',
        // 手机1
        /** 更多信息 */
        contactsNameTwo: '',
        // 联系人2
        contactsMobileTwo: '',
        // 手机2
        contactsNameThree: '',
        // 联系人3
        contactsMobileThree: '',
        // 手机3
        remarkOne: '',
        // 分类1
        remarkTwo: '',
        // 分类2
        remarkThree: '',
        // 分类3
        /** 零售店性质和人员情况 */
        customerTireBizYear: undefined,
        // 从事轿车轮胎零售历史 (年)
        customerTireSob: undefined,
        // 轿车轮胎占总业务量
        monthTireSalesAvg: undefined,
        // 轮胎月均总销量
        storeStructure: '',
        // 零售店性质
        staff: undefined,
        // 员工数
        /** 店招信息附店招照片 */
        signBoardBrand: '',
        // 店招品牌
        otherBrand: '',
        // 其他品牌
        installationDate: '',
        // 安装日期
        dueTime: '',
        // 到期日期
        photo1: '',
        // 门头照片
        photo2: '',
        // 照片1
        photo3: '',
        // 照片2
        /** 店内主要服务项目 */
        siTire: 'N',
        // 轮胎 选中(Y / N) Validate[regexp: Y|N; ]
        siMaintainence: 'N',
        // 保养 选中(Y / N) Validate[regexp: Y|N; ]
        siFastRepair: 'N',
        // 快修 选中(Y / N) Validate[regexp: Y|N; ]
        siBeauty: 'N',
        // 美容 选中(Y / N) Validate[regexp: Y|N; ]
        siWashing: 'N',
        // 洗车 选中(Y / N) Validate[regexp: Y|N; ]
        siOther: '',
        // 其他服务
        siMain: '',
        // 主要服务项目
        siMainPercentage: undefined,
        // 主要服务占比（营业额）
        /** 店内设施设备 */
        area: undefined,
        // 店面积
        workingBay: undefined,
        // 工位数
        accountingMethod: '',
        // 记账方式
        laundry: 'N',
        // 洗手间 (Y / N) Validate[regexp: Y|N; ]
        restRoom: 'N',
        // 客户休息室 (Y / N) Validate[regexp: Y|N; ]
        alignment: 'N',
        // 四轮定位 (Y / N) Validate[regexp: Y|N; ]
        fitting: 'N',
        // 装拆胎机 (Y / N) Validate[regexp: Y|N; ]
        balancing: 'N',
        // 动平衡机 (Y / N) Validate[regexp: Y|N; ]
        liftingMachine: 'N',
        // 举升机 (Y / N) Validate[regexp: Y|N; ]
        /** step2 销售情况 */
        tireSalesInfos: [
          // {
          //   key: 1,
          //   tireBrand: '品牌1', // 轮胎品牌
          //   tireSupplier: '', // 主要进货渠道 (DIS/SP 代理商 /Whole sales 批发商)
          //   paymentTerms: '', // 结款方式（现结/账期）
          //   monthlyAvgSales: undefined, // 月均销量
          //   stock: undefined // 库存
          // }
        ],
        tyreEighteenGreater: undefined // storeMix 比例
      },
      /** step5培训记录 */
      trainingInfo: {
        trainingCourse: '',
        // 培训内容
        trainingDate: '',
        // 培训日期
        trainingLocation: '',
        // 培训地点
        trainer: '',
        // 培训导师
        trainee: '',
        // 被培训人
        trainingChannel: '',
        // 培训方式
        gyTrainerComments: '',
        // 固特异培训导师评语
        trainingAchievement: '',
        // 效果达成
        nextTrainingPlan: '',
        // 下次培训计划
        remark: '' // 备注
      },
      /** 拜访数据 */
      visitParam: {
        participant: '',
        // 与会者
        visitPurposeOne: '',
        // 拜访目的1
        visitPurposeTwo: '',
        // 拜访目的2
        visitPurposeThree: '',
        // 拜访目的3
        topic1: '',
        // 主题1
        detail1: '',
        // 明细1
        topic2: '',
        // 主题2
        detail2: '',
        // 明细2
        topic3: '',
        // 主题3
        detail3: '',
        // 明细3
        topic4: '',
        // 主题4
        detail4: '',
        // 明细4
        followUpAction1: '',
        // 跟进事项1
        followUpAction2: '',
        // 跟进事项2
        followUpAction3: '',
        // 跟进事项3
        followUpDate1: '',
        // 跟进截止日1
        followUpDate2: '',
        // 跟进截止日2
        followUpDate3: '',
        // 跟进截止日3
        recordDetailStatus1: '',
        // 跟进事项1的状态 N:新建,D:完成
        recordDetailFinishedDatetime1: '',
        // 跟进事项1完成时间
        recordDetailStatus2: '',
        // 跟进事项2的状态 N:新建,D:完成
        recordDetailFinishedDatetime2: '',
        // 跟进事项2完成时间
        recordDetailStatus3: '',
        // 跟进事项3的状态 N:新建,D:完成
        recordDetailFinishedDatetime3: '',
        // 跟进事项3完成时间
        photos: [
          // "url": "test_ed470c31af38",
          // "fileName": "test_0b2a870a0638"
        ],
        // 照片
        files: [],
        // 文件
        // 检查项
        checkList: [
          // "checkListItem": "purpose1",
          // "checkListItemVal": "Y",
          // "sn": 1
        ],
        // BaiLian转化的门店独有的反馈信息参数
        recordFeedback: {
          'acceptTerms': null,
          'urgentDeliveryTime': null,
          'urgentDeliveryStartTime': null,
          'urgentDeliveryEndTime': null,
          'regularDeliveryTime': null,
          'regularDeliveryStartTime': null,
          'regularDeliveryEndTime': null,
          'willingToRtmOrder': null,
          'evaluateRate': 0,
          'badContent': [],
          'goodContent': [],
          'otherContent': []
        }
      },
      /** 其他额外增加的字段 */
      planTaskStartTime: '',
      // 开始时间
      planTaskEndTime: '' // 结束时间
    };
    var phoneRule = function phoneRule(rule, value, callback) {
      if (value && (0, _validate.validPhone)(value)) {
        callback(new Error(_this2.$t('errorValid.validPhone')));
      } else {
        callback();
      }
    };
    // 正整数判定
    var numberRule = function numberRule(rule, value, callback) {
      if (value && (0, _validate.isSn)(value)) {
        callback(new Error(_this2.$t('errorValid.validNumber')));
      } else {
        callback();
      }
    };
    var txtRule = function txtRule(rule, value, callback) {
      // if (value && validRule1(value)) {
      //   callback(new Error(this.$t('errorValid.validText')))
      // } else {
      //   callback()
      // }
      // 门店管理和访店报告，文字的字段不加限制
      callback();
    };
    var floatRule = function floatRule(rule, value, callback) {
      if (value) {
        if ((0, _validate.isFloat)(value)) {
          callback(new Error(_this2.$t('retailStoresInfo.error.float')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      loadSucess: true,
      // 编辑模式下，是否加载数据成功，失败不能点击
      step: _storage.LocalStorage.getItem(STORE_STEP) || 1,
      // 1-6
      /** 门店详情 */
      storeLoading: false,
      // 门店详情是否加载完成
      storeBaseInfo: Object.assign({}, defaultForm),
      // 门店信息
      /** form group */
      optConfig: {
        planTypeOptions: [],
        // 计划任务select
        planStatusOptions: [],
        // 计划状态select
        visitPurposeOptions: [],
        // 拜访目的select
        rtmOptions: [],
        // 门店RTM类型select
        storeCategoryOptions: [],
        // 客户类型select（零售店类别）
        tppOptions: [],
        // TPP签约量select
        storeStructureOptions: [],
        // 零售店性质select
        ssbtypeOptions: [],
        // 店招品牌select
        daMethodOptions: [],
        // 记账方式select
        tireSupplierOptions: [],
        // 主要进货渠道select
        accountMethodOptions: [],
        // 结算方式select
        tyreBrandOptions: [],
        // 轮胎品牌select
        mainserviceOptions: [],
        // 主要服务项目select
        trainingChannelOptions: [],
        // 培训方式select
        VRCheckListOptions: [],
        // 拜访报告的checklist
        RTypeOptions: [] // 零售店类别描述
      },
      form: Object.assign({}, defaultForm),
      rules: {
        /** 只校验正确性 */
        validatePhone: [{
          trigger: ['blur'],
          validator: phoneRule
        }],
        validateNumber: [{
          trigger: ['blur'],
          validator: numberRule
        }],
        validateIpt: [{
          trigger: ['blur'],
          validator: txtRule
        }],
        validateFloat: [{
          trigger: ['blur'],
          validator: floatRule
        }],
        /** 非空校验 */
        iptEmpty: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.empty')
        }],
        phoneEmpty: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptyPhone')
        }],
        chooseEmpty: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptySelect')
        }],
        uploadEmpty: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptyUpload')
        }],
        tyreEighteenGreaterEmpty: [
        // 2.销售情况
        {
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.empty')
        }]
      },
      /** other */
      dataFrom: '',
      // 数据来源，[空：还没读数据 | 'draft'：草稿 | 'new'：新建报告流程]
      ptInfo: {},
      // 计划任务详情
      canSubmit: true,
      feedbackCheckList: []
    };
  },
  computed: {
    isBailianFlag: function isBailianFlag() {
      var storeInfo = this.storeBaseInfo.storeInfo || {};
      return !!storeInfo.isBaiLian;
    },
    // 模式 view edit
    mode: function mode() {
      var mode = this.$route.query.mode;
      // 编辑模式下，加载数据失败，反馈为浏览模式
      if (!this.loadSucess) {
        return 'error';
      } else if (['view', 'edit'].indexOf(mode) >= 0) {
        return mode;
      } else {
        return 'edit';
      }
    },
    // 当前计划id
    taskId: function taskId() {
      return this.$route.query.planTaskInfoPk || '';
    },
    // TPP记录相关信息
    tppinfo: function tppinfo() {
      var _ref = this.storeBaseInfo || {},
        tppVo = _ref.tppVo;
      return tppVo || {};
    },
    // 当前门店是否潜在客户
    isQzkh: function isQzkh() {
      var storeInfo = this.storeBaseInfo.storeInfo || {};
      return storeInfo.rtlRtmCategory === 'potential';
    }
  },
  watch: {
    // 依据类型生成销售记录表格
    'optConfig.tyreBrandOptions': {
      immediate: true,
      deep: true,
      handler: function handler(val) {
        var _this3 = this;
        var newTable = (val || []).map(function (item) {
          return {
            key: item.code,
            tireBrand: item.name,
            // 轮胎品牌
            tireSupplier: '',
            // 主要进货渠道 (DIS/SP 代理商 /Whole sales 批发商)
            paymentTerms: '',
            // 结款方式（现结/账期）
            monthlyAvgSales: undefined,
            // 月均销量
            stock: undefined // 库存
          };
        });
        // 合并数据
        this.$nextTick(function () {
          _this3.initSalesTable(newTable, true);
        });
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.queryEnumOptions();
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    console.log('beforeRouteLeave');
    _storage.LocalStorage.removeItem(STORE_STEP);
    next();
  },
  mounted: function mounted() {
    console.log('mounted', this.mode);
    this.queryEnumOptions(); // 枚举
    if (this.mode === 'edit') {
      // 编辑
      this.initEditPage(); // 初始化报告数据（草稿、详情）
    } else {
      // 查看
      this.initViewPage();
    }
    this.queryPlanInfo(); // 获取任务详情
    this.queryPlanTaskAllocated();
  },
  methods: {
    /** 获取计划类型 enum */queryEnumOptions: function queryEnumOptions() {
      var _this4 = this;
      var type_key = 'PLAN_TASK_TYPE';
      var status_key = 'PLAN_TASK_STATUS';
      var visitPurpose_key = 'VISIT_PURPOSE';
      var rtm_key = 'STORE_RTM_TYPE';
      var storeCategory_key = 'STORE_CATEGORY';
      var TPP_key = 'TPP_SIGN_ASC_GY';
      var storeStructure_key = 'STORE_STRUCTURE'; // 零售店性质
      var ssbtype_key = 'STORE_SIGN_BRAND_TYPE'; // 店招品牌
      var daMethod_key = 'DETAILS_ACCOUNTING_METHOD'; // 记账方式
      var tireSupplier_key = 'TIRE_SUPPLIER'; // 主要进货渠道
      var accountMethod_key = 'ACCOUNTING_METHOD'; // 结算方式
      var tyreBrand_key = 'TYRE_BRAND'; // 轮胎品牌
      var mainserviceItems_key = 'MAIN_SERVICE_ITEMS'; // 主要服务项目
      var trainingChannel_key = 'TRAINING_CHANNEL'; // 培训方式
      var VRCheckList_key = 'Visit_Report_Check_list'; // 拜访报告的checklist
      var RType_key = 'Retailer_Type_description'; // 零售店类别描述
      var urgentDeliveryTime_key = 'URGENT_DELIVERY_TIME'; // 紧急订单物流时效选项
      var regularDeliveryTime_key = 'REGULAR_DELIVERY_TIME'; // 常规订单物流时效选项
      var goodContent_key = 'RECORD_FEEDBACK_GOOD'; // 意见反馈正面评价选项
      var badContent_key = 'RECORD_FEEDBACK_BAD'; // 意见反馈反面评价选项
      var param = {
        configItemCodeList: [type_key, status_key, visitPurpose_key, rtm_key, storeCategory_key, TPP_key, storeStructure_key, ssbtype_key, daMethod_key, tireSupplier_key, accountMethod_key, tyreBrand_key, mainserviceItems_key, trainingChannel_key, VRCheckList_key, RType_key, urgentDeliveryTime_key, regularDeliveryTime_key, goodContent_key, badContent_key]
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        var data = res.data || {};
        // console.log(999, res)
        _this4.optConfig = {
          planTypeOptions: data[type_key] || [],
          planStatusOptions: data[status_key] || [],
          visitPurposeOptions: data[visitPurpose_key] || [],
          rtmOptions: data[rtm_key] || [],
          storeCategoryOptions: data[storeCategory_key] || [],
          tppOptions: data[TPP_key] || [],
          storeStructureOptions: data[storeStructure_key] || [],
          ssbtypeOptions: data[ssbtype_key] || [],
          daMethodOptions: data[daMethod_key] || [],
          tireSupplierOptions: data[tireSupplier_key] || [],
          accountMethodOptions: data[accountMethod_key] || [],
          tyreBrandOptions: data[tyreBrand_key] || [],
          mainserviceOptions: data[mainserviceItems_key] || [],
          trainingChannelOptions: data[trainingChannel_key] || [],
          VRCheckListOptions: data[VRCheckList_key] || [],
          RTypeOptions: data[RType_key] || [],
          urgentDeliveryTimeOptions: data[urgentDeliveryTime_key] || [],
          regularDeliveryTimeOptions: data[regularDeliveryTime_key] || [],
          goodContentOptions: data[goodContent_key] || [],
          badContentOptions: data[badContent_key] || []
        };
      });
    },
    // 初始化查看数据
    initViewPage: function initViewPage() {
      var _this5 = this;
      if (!this.taskId) {
        console.log('没有计划PK，请检查逻辑');
        // 页面ui展示
        return false;
      }
      this.storeLoading = true;
      var params = {
        planTaskInfoPk: this.taskId
      };
      (0, _doubleWeekPlan.getReportDetail)(params).then(function (infoRes) {
        var _ref2 = infoRes || {},
          infoData = _ref2.data;
        // 编辑数据（详情）赋值（预扩展编辑功能）
        // 单独格式化销售数据
        var tireSalesInfos = [].concat(infoData.storeInfo.tireSalesInfos || []);
        delete infoData.storeInfo.tireSalesInfos;
        _this5.initSalesTable(tireSalesInfos);
        // 其他所有数据格式化
        _this5.form = _lodash.default.merge({}, _this5.form, infoData);
        // 如果后续扩展编辑 省市区等插件单独赋值，参照edit模式下，草稿与详情的混合
        // 原详情赋值
        _this5.storeBaseInfo = _lodash.default.merge({}, _this5.storeBaseInfo, infoData);
      }).finally(function () {
        _this5.storeLoading = false;
      });
    },
    // 编辑 初始化数据
    initEditPage: function initEditPage() {
      var _this6 = this;
      if (!this.taskId) {
        console.log('没有计划PK，请检查逻辑');
        // 页面ui展示
        return false;
      }
      this.storeLoading = true;
      var baseinfoParams = {
        planTaskInfoPk: this.taskId,
        visitOperationType: 1
      };
      var draftParams = {
        planTaskInfoPk: this.taskId
      };
      Promise.all([(0, _doubleWeekPlan.getStoreBaseInfo)(baseinfoParams), (0, _doubleWeekPlan.getDraftReport)(draftParams)]).then(function (_ref3) {
        var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
          infoRes = _ref4[0],
          draftRes = _ref4[1];
        _this6.loadSucess = true;
        // 初始化数据
        var _ref5 = infoRes || {},
          infoData = _ref5.data;
        var _ref6 = draftRes || {},
          draftData = _ref6.data;
        // console.log(333, infoData, draftData.storeInfo.contactsNameTwo)
        if (draftData.storeInfo) {
          // 编辑 草稿数据
          console.log('编辑 草稿数据');
          _this6.dataFrom = 'draft';
          // 单独格式化销售数据
          var tireSalesInfos = [].concat(draftData.storeInfo.tireSalesInfos || []);
          delete draftData.storeInfo.tireSalesInfos;
          _this6.initSalesTable(tireSalesInfos);
          // 图片数据必须是个数组
          if (!draftData.visitParam.photos) {
            draftData.visitParam.photos = [];
          }
          if (!draftData.visitParam.dynamicDataList) {
            draftData.visitParam.dynamicDataList = [];
          }
          // 其他所有数据格式化
          _this6.form = _lodash.default.merge({}, _this6.form, draftData);
        } else {
          // 新增 数据
          console.log('新增 数据');
          _this6.dataFrom = 'new';
          // 单独格式化销售数据
          var _tireSalesInfos = [].concat(infoData.storeInfo.tireSalesInfos || []);
          delete infoData.storeInfo.tireSalesInfos;
          _this6.initSalesTable(_tireSalesInfos);
          // 其他所有数据格式化
          _this6.form = _lodash.default.merge({}, _this6.form, infoData);
        }
        // 省市区插件单独赋值
        if (_this6.form.storeInfo) {
          var _this6$form$storeInfo = _this6.form.storeInfo,
            rtlRegionCode = _this6$form$storeInfo.rtlRegionCode,
            rtlCityCode = _this6$form$storeInfo.rtlCityCode,
            rtlDistrictCode = _this6$form$storeInfo.rtlDistrictCode;
          _this6.form.storeInfo.PCD = [rtlRegionCode, rtlCityCode, rtlDistrictCode];
        }
        // 原详情赋值
        _this6.storeBaseInfo = _lodash.default.merge({}, _this6.storeBaseInfo, infoData);
      }).catch(function (err) {
        console.log('出错了', err);
        _this6.loadSucess = false;
      }).finally(function () {
        _this6.storeLoading = false;
      });
    },
    // 获取计划详情
    queryPlanInfo: function queryPlanInfo() {
      var _this7 = this;
      var params = {
        planTaskInfoPk: this.taskId
      };
      (0, _doubleWeekPlan.getPlanInfo)(params).then(function (res) {
        _this7.ptInfo = Object.assign({}, res.data || {});
        // console.log(999, this.ptInfo)
        // 在编辑模式下 针对step6的拜访目的做初始化 只有未读到数据｜新增流程才能从任务详情内初始化
        if (_this7.mode === 'edit' && ['', 'new'].indexOf(_this7.dataFrom) >= 0) {
          _this7.form.planTaskStartTime = _this7.ptInfo.planTaskStartTime;
          _this7.form.planTaskEndTime = _this7.ptInfo.planTaskEndTime;
          _this7.form.visitParam.visitPurposeOne = _this7.ptInfo.visitPurposeOne;
          _this7.form.visitParam.visitPurposeTwo = _this7.ptInfo.visitPurposeTwo;
        }
      });
    },
    queryPlanTaskAllocated: function queryPlanTaskAllocated() {
      var _this8 = this;
      (0, _doubleWeekPlan.getPlanTaskAllocatedInfo)({}).then(function (res) {
        console.log(res);
        _this8.feedbackCheckList = res.data || [];
      });
    },
    /**
     * 格式化销售表格
     * @param {array} tables // 合并数据
     * @param {boolean} isBase // 是否基础数据，基础数据不能覆盖原数据
     */
    initSalesTable: function initSalesTable(tables, isBase) {
      var _ref7 = this.form.storeInfo || {},
        _ref7$tireSalesInfos = _ref7.tireSalesInfos,
        tireSalesInfos = _ref7$tireSalesInfos === void 0 ? [] : _ref7$tireSalesInfos;
      var arr = [].concat(tireSalesInfos || []);
      var tireBrandMap = new Map();
      // 合并数据
      if (isBase) {
        // 合并的是基础数据
        if (tables && tables.length) {
          tables.forEach(function (item) {
            // 确保有轮胎品牌后初始化对应数据
            if (item.tireBrand) {
              tireBrandMap.set(item.tireBrand, Object.assign({}, TireSales_demo, item));
            }
          });
        }
        arr.forEach(function (item) {
          // 确保有轮胎品牌
          if (item.tireBrand) {
            tireBrandMap.set(item.tireBrand, item);
          }
        });
      } else {
        // 合并是最新数据，需覆盖
        arr.forEach(function (item) {
          // 确保有轮胎品牌
          if (item.tireBrand) {
            tireBrandMap.set(item.tireBrand, item);
          }
        });
        if (tables && tables.length) {
          tables.forEach(function (item) {
            // 确保有轮胎品牌后初始化对应数据
            if (item.tireBrand) {
              tireBrandMap.set(item.tireBrand, Object.assign({}, TireSales_demo, item));
            }
          });
        }
      }
      var lastArr = Array.from(tireBrandMap, function (_ref8) {
        var _ref9 = (0, _slicedToArray2.default)(_ref8, 2),
          key = _ref9[0],
          item = _ref9[1];
        return item;
      });
      this.$set(this.form.storeInfo, 'tireSalesInfos', lastArr);
      // console.log(999, lastArr, this.form.storeInfo.tireSalesInfos)
    },
    // 跳转，已在组件内过滤
    jumpStep: function jumpStep(targetStep) {
      this.step = targetStep;
      _storage.LocalStorage.setItem(STORE_STEP, targetStep);
    },
    // 保存草稿
    onSaveDraft: function onSaveDraft(cb) {
      var _this9 = this;
      // 重复触发
      if (!this.canSubmit) {
        return false;
      }
      this.canSubmit = false;
      this.storeLoading = true;
      var formatInfo = Object.assign({}, ((0, _objectDestructuringEmpty2.default)(this.form), this.form));
      // delete formatInfo.storeInfo.PCD
      var params = (0, _objectSpread2.default)({
        planTaskInfoPk: this.taskId
      }, formatInfo);
      if (formatInfo.storeInfo.photo1Lat === 0) {
        formatInfo.storeInfo.photo1Lat = '0.0';
      }
      if (formatInfo.storeInfo.photo1Long === 0) {
        formatInfo.storeInfo.photo1Long = '0.0';
      }
      (0, _doubleWeekPlan.submitDraftReport)(params).then(function () {
        cb && cb();
      }).catch(function () {}).finally(function () {
        _this9.canSubmit = true;
        _this9.storeLoading = false;
      });
    },
    // 下一步(保存草稿)
    onSaveDraftAndGo: function onSaveDraftAndGo(targetStep) {
      var _this0 = this;
      if (this.mode === 'edit') {
        // 编辑模式
        this.onSaveDraft(function () {
          if (targetStep >= 1 && targetStep <= 6) {
            _this0.jumpStep(targetStep);
          }
        });
      } else {
        // 预览模式
        this.jumpStep(targetStep);
      }
    },
    // step6 确定按钮点击（保存｜草稿）
    onEnsureDialog: function onEnsureDialog() {
      var _this1 = this;
      this.$confirm(this.$t('storeVisitReport.common.submitTip'), {
        confirmButtonText: this.$t('storeVisitReport.common.submit'),
        cancelButtonText: this.$t('storeVisitReport.common.disSubmit'),
        type: 'warning'
      }).then(function () {
        console.log('保存报告');
        _this1.onSaveReport();
      }).catch(function () {
        console.log('保存草稿');
        _this1.onSaveDraft();
      });
    },
    // 保存报告
    onSaveReport: function onSaveReport() {
      var _this10 = this;
      var _this = this;
      // 重复触发
      if (!this.canSubmit) {
        return false;
      }
      this.canSubmit = false;
      this.storeLoading = true;
      var formatInfo = Object.assign({}, ((0, _objectDestructuringEmpty2.default)(this.form), this.form));
      delete formatInfo.storeInfo.PCD;
      var params = (0, _objectSpread2.default)({
        planTaskInfoPk: this.taskId
      }, formatInfo);
      (0, _doubleWeekPlan.submitReport)(params).then(function () {
        _this10.$message({
          message: _this10.$t('storeVisitReport.common.saveReportSuccess'),
          type: 'success',
          onClose: function onClose() {
            // 跳转计划列表页面
            _this.jumpPlanTaskPage();
          }
        });
        console.log('保存完成');
      }).catch(function () {}).finally(function () {
        _this10.canSubmit = true;
        _this10.storeLoading = false;
      });
    },
    // 跳转计划列表页面
    jumpPlanTaskPage: function jumpPlanTaskPage() {
      this.$router.push({
        path: '/planModule/doubleWeekPlan'
      });
    }
  }
};